import axios from "./axiosConfig";

export function saveErrorReport(data) {
    return axios.post('/api/v1/addReportErrorService', data);
}
